<template>
  <section class="mock-calculate">
    <div
      v-show="step === 0"
      class="abs-top-right">
      <v-button @click="handlerCancel">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerNext">Next</v-button>
    </div>

    <section v-show="step === 0">
      <h2>Select Starting Point</h2>
      <span>Choose a starting point for mock calculating endorsement price.</span>
    </section>

    <section v-show="step === 0">
      <policy-record
        ref="policy-record"
        :form="form"
        @submit="getPolicyData" />
    </section>
    <section v-show="step === 1">
      <edit-policy
        :form="formData"
        :mock="true"
        :ticketId="ticketId"
        :orderId="orderId"
        @back="handlerBack"
        @done="handlerCancel" />
    </section>

  </section>
</template>
<script>
import PolicyRecord from './policy-record'
import EditPolicy from './edit-policy'

export default {
  name: 'MockCalculate',
  components: {
    PolicyRecord,
    EditPolicy
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    ticketId: {
      type: [String, Number],
      default: ''
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      step: 0,
      formData: {}
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    handlerCancel() {
      this.$emit('close')
    },
    handlerBack() {
      this.step -= 1
    },
    handlerNext() {
      // this.step += 1
      this.$refs['policy-record'].submitForm()
    },
    getPolicyData(data) {
      this.formData = data
      this.step += 1
    },
    handlerDone() {

    }
  }
}
</script>
<style lang="scss" scoped>
.mock-calculate {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 15px;
        right: 15px;
    }
    h2 {
        padding-bottom: 5px;
    }
    h2 + span {
        display: inline-block;
        padding-bottom: 10px;
        color: #91939A;
        font-size: 16px;
    }
}
</style>